angular.module('impactx.rfq').controller('RFQListOpenCtrl', ['$scope', '$redirect', 'selectedListItems', 'dataGen', 'ToastService', '$context', RFQListOpenCtrl]);

function RFQListOpenCtrl($scope, $redirect, selectedListItems, dataGen, ToastService)
{
    var self = this;

    this.getDetailLink = function() {
        return impactX.isDefined(selectedListItems.getFirstSelectedItem(), "isMultiSupplier.value") ?
             "multirfq/" + selectedListItems.getFirstSelectedId() : "singlerfqbuyer/" + selectedListItems.getFirstSelectedId();
    };

    this.addToCurrentBasket = function() {
        dataGen.postAsForm({}, {rfqsId: selectedListItems.getFirstSelectedId()}, "/rfq/addtobasketrfqs").then(function(data)
        {
            $context.refreshBasket({}, dataGen, $context);
            ToastService.openStandardToast(data.trns.success);
            $redirect.redirectTo(null, "/basket");
        }, function () {
            $context.refreshBasket({}, dataGen, $context);
        });
    };

    this.canAddToCurrentBasket = function() {
        return selectedListItems.isSingleSelection() && impactX.isDefined(selectedListItems.getFirstSelectedItem(), "canOrder.value");
    };

    var buttonDefinition = [
        {label: "details", linkFunction: self.getDetailLink, type:'link', condition:  selectedListItems.isSingleSelection, process: 'RFQBuyer'},
        {label: "addToBasket", action: self.addToCurrentBasket, condition:  self.canAddToCurrentBasket, process: 'RFQBuyer'}
    ];

    this.meta = {
        rowTemplate: 'modules/rfq/templates/rfqlist.row.tmpl.html',
        filtersTemplate: 'modules/rfq/templates/rfqlist.filters.tmpl.html',
        mainAction: {id: "new", link: "#/singlerfqbuyer/0", icon: "mdi-plus"},
        isSelectAble: true,
        ctrl: this,
        endpoint: '/rfq/listopen',
        id: "rfqlistopen",
        buttonDefinition: buttonDefinition
    };
    this.getMeta = function () {
        return this.meta;
    };

    this.processStatus = {value: "open"};
    $scope.$watch(function() {
        return self.processStatus.value;
    }, function(newValue) {
        if(newValue === "offer") {
            $redirect.redirectTo(null, "/rfqlistoffer");
        } else if (newValue === "prep") {
            $redirect.redirectTo(null, "/rfqlistprep");
        } else if (newValue === "closed") {
            $redirect.redirectTo(null, "/rfqlistclosed");
        }
    });
}